import { type DocumentNode, gql } from '@apollo/client';

const staffStatus: DocumentNode = gql`
  query staff {
    me {
      id
      role
      firstName
      lastName
      user {
        id
        username
      }
    }
  }
`;

export default staffStatus;
